var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M49.75,31.5h0v5.43L38,48.7a2.25,2.25,0,0,1-3.18-3.18L52,28.32l17.2,17.2A2.25,2.25,0,0,1,66,48.7L54.25,36.93V63h-4.5V31.5Zm0,31.5H20.5V18h63V63H54.25v4.5H88V18a4.51,4.51,0,0,0-4.5-4.5h-63A4.5,4.5,0,0,0,16,18V67.5H54.25V63Zm0,22.5h4.5v-18h-4.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.9fab27f8ca1729fa4c19e2f73c6a3d34.svg";
export { ForwardRef as ReactComponent };